export const serviceSetupStatuses = {
    DRAFT: "DRAFT",
    APPROVAL_PENDING: "APPROVAL_PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
    FAILED: "FAILED",
    BLOCKCHAIN_SUBMITTED: "BLOCKCHAIN_SUBMITTED",
    PUBLISHED: "PUBLISHED",
};
